module.exports = __webpack_public_path__ + "static/media/FORMATO CARTA DE MOTIVACION SIN EXPERIENCIA.578c49a8.docx";